import { capitalizeWords } from '@/utils/validators';
import { Input, InputProps } from '@headlessui/react';
import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { BaseInput } from './BaseInput';

type TextInputProps = InputProps & {
  label?: string;
  error?: string;
  required?: boolean;
  /** Optional left-side adornment, e.g. "RM" for a currency field. */
  prefix?: ReactNode;
};

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ label, error, required, className, prefix, ...props }, ref) => {
    return (
      <BaseInput
        label={capitalizeWords(label ?? '')}
        error={error}
        required={required}
      >
        <div
          className={twMerge(
            'flex w-full items-stretch overflow-hidden rounded-lg border border-[#CBCBCB] bg-white text-primary',
            'focus-within:border-[#FFBF00] focus-within:outline-none focus-within:ring-0',
            props.disabled && 'bg-[#F2F2F2] text-disabled',
            error && 'border-error',
          )}
        >
          {prefix !== undefined && prefix !== null && (
            <span
              className={twMerge(
                'flex select-none items-center border-r border-[#CBCBCB] bg-[#F8F8F8] px-3 text-primary',
                props.disabled && 'text-disabled',
              )}
            >
              {prefix}
            </span>
          )}
          <Input
            ref={ref}
            className={twMerge(
              'flex w-full gap-2.5 border-0 bg-transparent px-4 py-2 text-primary',
              'focus:outline-none focus:ring-0',
              props.disabled && 'text-disabled',
              className as string,
            )}
            type="text"
            {...props}
            placeholder={capitalizeWords(props.placeholder ?? '')}
          />
        </div>
      </BaseInput>
    );
  },
);

TextInput.displayName = 'TextInput';
